<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('reportCard.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t('reportCard.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-3">
            <ts-loading-banner :loading="loading">
              <div class="card border-0">
                <div class="card-body" style="background-color: #20252a; border-radius: 5px">
                  <div class="text-gray-500">
                    <b>{{ $t('reportCard.filterCriteria') }}</b>
                  </div>
                </div>
                <div class="widget-list rounded-bottom">
                  <div class="row form-group mt-2">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('cashCollectionByCashier.branchName')
                      }}</label>
                      <a-select style="width: 100%" v-model.number="model.branch_id" :options="branches"
                        :show-search="true" :filter-option="(input, option) =>
                          option.componentOptions.children[0].text
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                          ">
                      </a-select>
                      <div class="validate" v-if="errors.has('branch_id')">
                        {{ errors.first('branch_id') }}
                      </div>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('reportCard.mainProgram')
                      }}</label>
                      <a-select style="width: 100%" v-model.number="model.acp_id" :options="main_programs"
                        :show-search="true" :filter-option="(input, option) =>
                          option.componentOptions.children[0].text
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                          " @change="onMainProgramChange"></a-select>
                      <div class="validate" v-if="errors.has('acps_id')">
                        {{ errors.first('acps_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('reportCard.subProgram')
                      }}</label>
                      <a-select style="width: 100%" v-model.number="model.acps_id" :options="sub_programs"
                        :show-search="true" :filter-option="(input, option) =>
                          option.componentOptions.children[0].text
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                          " @change="onSubChange" :disabled="!model.acp_id"></a-select>
                      <div class="validate" v-if="errors.has('acps_id')">
                        {{ errors.first('acps_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('reportCard.acYear')
                      }}</label>
                      <a-select style="width: 100%" v-model.number="model.ac_year_id" :options="ac_year_list"
                        :loading="fetching_academic_year" @change="acYearChange"></a-select>
                      <div class="validate" v-if="errors.has('ac_year_id')">
                        {{ errors.first('ac_year_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('reportCard.acTerm')
                      }}</label>
                      <a-select style="width: 100%" v-model.number="model.ac_term_id" :options="acTerms"
                        :show-search="true" :loading="fetching_academic_term" :filter-option="(input, option) =>
                          option.componentOptions.children[0].text
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                          " @change="acTermChange"></a-select>
                      <div class="validate" v-if="errors.has('ac_term_id')">
                        {{ errors.first('ac_term_id') }}
                      </div>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('reportCard.classOperation')
                      }}</label>
                      <a-select style="width: 100%" v-model="model.class_id" :options="class_options"
                        :show-search="true" :placeholder="$t('all')" :loading="fetching_class_operation" :filter-option="(input, option) =>
                          option.componentOptions.children[0].text
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                          " @change="classChange"></a-select>
                      <div class="validate" v-if="errors.has('class_id')">
                        {{ errors.first('class_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{ $t('reportCard.student') }}</label>
                      <a-select style="width: 100%" v-model="model.student_id" :options="students" :show-search="true"
                        :maxTagCount="2" :loading="fetching_student" :disabled="fetching_student"
                        :placeholder="$t('all')" mode="multiple" :filter-option="(input, option) =>
                          option.componentOptions.children[0].text
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                          "></a-select>
                      <div class="validate" v-if="errors.has('student_id')">
                        {{ errors.first('student_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('reportCard.scoringCycle')
                      }}</label>
                      <div class="form-group">
                        <a-select style="width: 100%" v-model="model.scoring_cycle_id" :options="scoringCycles"
                          @change="scoringCycleChange">
                        </a-select>
                        <div class="validate" v-if="errors.has('scoring_cycle_id')">
                          {{ errors.first('scoring_cycle_id') }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row form-group" v-if="!reportType">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('reportCard.cycleValue')
                      }}</label>
                      <a-select style="width: 100%" v-model="model.cycle_value" :disabled="reportType"
                        :options="scoringCycleValues">
                      </a-select>
                      <div class="validate" v-if="errors.has('cycle_value')">
                        {{ errors.first('cycle_value') }}
                      </div>
                    </div>
                  </div>
                  <!-- close for english program -->
                  <div class="row form-group" v-if="false">
                    <!-- <div class="col-md-12"> -->
                    <a-radio-group v-model="model.type" class="col-md-12">
                      <a-radio-button value="rankings" class="ts-w-1/2">Rankings</a-radio-button>
                      <a-radio-button value="top" class="ts-w-1/2">Honorary List</a-radio-button>
                    </a-radio-group>
                    <!-- </div> -->
                  </div>
                  <div class="form-group">
                    <ts-checkbox v-model="model.is_transcript">{{
                      $t('reportCard.transcript')
                    }}</ts-checkbox>
                  </div>
                  <div class="row">
                    <div class="col-md-6 text-center">
                      <ts-button class="btn-block" outline color="success" @click.prevent="exportExcel"
                        :waiting="exporting">{{ $t('excel') }}</ts-button>
                    </div>
                    <div class="col-md-6 text-center">
                      <ts-button class="btn-block" color="primary" @click.prevent="preview" :waiting="waiting">{{
                        $t('preview') }}</ts-button>
                    </div>
                  </div>
                </div>
              </div>
            </ts-loading-banner>
          </div>
          <div class="col-md-9">
            <ts-preview-pdf v-model="waiting" :src="src" />
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import * as FileDownload from 'downloadjs'
import { trim, includes } from 'lodash'

export default {
  name: 'reportCard',
  data() {
    return {
      loading: false,
      waiting: false,
      exporting: false,
      fetching_academic_year: false,
      fetching_academic_term: false,
      fetching_class_operation: false,
      fetching_student: false,
      src: '',
      errors: new Errors(),
      branches: [],
      scoringCycle: [],
      scoringCycleValue: [],
      ac_year_list: [],
      main_programs: [],
      sub_programs: [],
      ac_terms: [],
      class_options: [],
      students: [],
      grade: [],
      term_order: null,
      model: {
        is_transcript: false,
        scoring_cycle_id: null,
        branch_id: null,
        ac_year_id: null,
        ac_term_id: null,
        acp_id: null,
        acps_id: null,
        class_id: null,
        grade_id: null,
        cycle_value: null,
        type: 'rankings',
        student_id: []
        // report_type: 'english'
        // submission_date: moment().format('DD-MM-YYYY')
      }
    }
  },
  computed: {
    ...mapState('reportAcademic', ['studentStatus']),
    scoringCycles() {
      if (this.model.acps_id) {
        let scoring_cyles = this.sub_programs.find(
          el => el.value == this.model.acps_id
        ).scoring_cyles
        if (this.term_order < 2) {
          return this.scoringCycle
            .filter(el => includes(scoring_cyles, el.value))
        }
        return this.scoringCycle.filter(el => includes(scoring_cyles, el.value))
      }
      return this.scoringCycle
    },
    grades() {
      return this.grade
    },
    reportType() {
      if (
        this.model.scoring_cycle_id == 5 ||
        this.model.scoring_cycle_id == 1 ||
        this.model.scoring_cycle_id == 7
      ) {
        return false
      }
      return true
    },
    scoringCycleValues() {
      if (this.model.scoring_cycle_id) {
        // Termly For ELT
        if (this.model.scoring_cycle_id == 7 && this.model.ac_term_id) {
          return this.scoringCycleValue
            .filter(s => s.scoring_cycle_id == this.model.scoring_cycle_id)
            .filter(el =>
              includes(this.term_order == 1 ? [1, 2] : [3, 4, 5], el.value)
            )
        }
        // Unit For ELT
        if (this.model.scoring_cycle_id == 5 && this.model.ac_term_id) {
          return this.scoringCycleValue
            .filter(s => s.scoring_cycle_id == this.model.scoring_cycle_id)
            .filter(el =>
              includes(this.term_order == 1 ? [1, 2, 3] : [4, 5, 6], el.value)
            )
        }
        return this.scoringCycleValue.filter(
          s => s.scoring_cycle_id == this.model.scoring_cycle_id
        )
      }
      return this.scoringCycleValue
    },
    acTerms() {
      // For AIA 1 year has 2 semester
      // scoring_cycle_id = 4 is for yearly cycle
      // term order = 2 is for semester 2
      if (this.model.scoring_cycle_id == 4) {
        return this.ac_terms.filter(s => s.term_order == 2) // yealy report get class operation on semester 2 or end of year
      }
      return this.ac_terms
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('reportAcademic', [
      'reportCard',
      'getBranch',
      'getYear',
      'getMainProgram',
      'getSubProgram',
      'getTerm',
      'getClass',
      'getStudentPofile',
      'getScoringCycle',
      'getScoringCycleValue',
      'getGrade',
      'exportCardExcel',
      'getStudentPofileAllBranch'
    ]),
    // Fetch Data
    async fetchData() {
      this.loading = true
      await this.getBranch().then(response => {
        this.branches = response.data.map(el => ({
          value: el.branch_id,
          label: el.branch_name_en
        }))
      })
      await this.getMainProgram()
        .then(response => {
          this.main_programs = response.data
            // .filter(mp => mp.acp_id == 101) // acp_id = 102 is English program in ASEAN
            .map(el => ({
              value: el.acp_id,
              label: el.acp_name_foreign
            }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
          this.model.branch_id = parseInt(this.$store.state.authUser.default_branch_id)
          this.model.acp_id = this.main_programs[0].value
          if (this.model.acp_id) {
            this.getSubProgram({
              filter: {
                acp_id: this.model.acp_id
              }
            })
              .then(response => {
                this.sub_programs = response.data.map(el => ({
                  value: el.acps_id,
                  label: el.acps_name_foreign,
                  scoring_cyles: el.scoring_cyles.map(el => el.scoring_cycle_id)
                }))
              })
              .catch(error => {
                this.$toasted.error(error.message)
              })
              .finally(() => {
                this.loading = false
                this.model.acps_id = this.sub_programs[0].value
                if (this.model.acps_id) {
                  this.getTerm({
                    filter: {
                      acps_id: this.model.acps_id,
                      ac_year_id: this.model.ac_year_id,
                      branch_id: this.model.branch_id,
                      ac_status_id: '1,2,3',
                    }
                  })
                    .then(response => {
                      this.ac_terms = response.data.map(
                        el => ({
                          value: el.ac_term_id,
                          ac_status_id: el.ac_status_id,
                          term_order: el.term_order,
                          label: el.term_name +
                            (el.ac_status_id == 1
                              ? ' ( Current ) '
                              : el.ac_status_id == 2
                                ? ' ( History ) '
                                : '( Next )')
                        })
                      )
                    })
                    .catch(error => {
                      this.$toasted.error(error.message)
                    })
                    .finally(() => {
                      this.loading = false
                      this.ac_terms.filter(el => el.ac_status_id == 1).map(el =>
                        this.model.ac_term_id = el.value
                      )
                      if (this.model.ac_term_id) {
                        this.getClass({
                          filter: {
                            ac_term_id: this.model.ac_term_id,
                            branch_id: this.model.branch_id
                          }
                        })
                          .then(response => {
                            this.class_options = response.data.map(el => ({
                              value: el.class_id,
                              label:
                                el.class_name +
                                ' | ' +
                                (el.teacher ? el.teacher.full_name_en + ' | ' : '') +
                                el.academic_study_time.study_time,
                              grade_id: el.grade_id
                            }))
                          })
                          .catch(error => {
                            this.$toasted.error(error.message)
                          })
                          .finally(() => {
                            this.fetching_class_operation = false
                            this.model.class_id = this.class_options[0].value
                            this.model.grade_id = this.class_options[0].grade_id
                            if (this.model.class_id) {
                              this.getStudentPofile({
                                filter: {
                                  student_in_class: this.model.class_id
                                }
                              })
                                .then(response => {
                                  this.students = response.data.map(el => ({
                                    value: el.student_id,
                                    label: el.full_name_en
                                  }))
                                })
                                .catch(error => {
                                  this.$toasted.error(error.message)
                                })
                                .finally(() => {
                                  this.loading = false
                                })
                            }
                          })
                      }
                    })
                  this.getScoringCycle({
                    acps_id: this.model.acps_id
                  })
                    .then(response => {
                      this.scoringCycle = response.data.map(el => ({
                        value: el.scoring_cycle_id,
                        label: el.scoring_cycle_name
                      }))
                    })
                    .catch(error => {
                      this.$toasted.error(error.message)
                    })
                    .finally(() => {
                      this.loading = false
                      this.model.scoring_cycle_id = this.scoringCycle[0].value
                      if (
                        this.model.scoring_cycle_id == 0 ||
                        this.model.scoring_cycle_id == 2 ||
                        this.model.scoring_cycle_id == 3 ||
                        this.model.scoring_cycle_id == 6
                      ) {
                        this.getScoringCycleValue({ scoring_cycle_id: this.model.scoring_cycle_id })
                          .then(response => {
                            this.scoringCycleValue = response.data.map(el => ({
                              value: el.scoring_cycle_value,
                              label: el.scoring_cycle_description,
                              scoring_cycle_id: el.scoring_cycle_id
                            }))
                          })
                          .catch(error => {
                            this.$toasted.error(error.message)
                          })
                          .finally(() => {
                            this.loading = false
                            this.model.cycle_value = this.ac_terms.find(
                              el => el.value == this.model.ac_term_id
                            ).term_order
                          })
                      } else {
                        this.getScoringCycleValue({ scoring_cycle_id: this.model.scoring_cycle_id })
                          .then(response => {
                            this.scoringCycleValue = response.data.map(el => ({
                              value: el.scoring_cycle_value,
                              label: el.scoring_cycle_description,
                              scoring_cycle_id: el.scoring_cycle_id
                            }))
                          })
                          .catch(error => {
                            this.$toasted.error(error.message)
                          })
                          .finally(() => {
                            this.loading = false
                            this.model.cycle_value = this.scoringCycleValue[0].value
                          })
                      }
                    })
                }
              })
          }
          if (this.model.branch_id) {
            this.getYear({
              filter: {
                branch_id: this.model.branch_id,
                ac_status_id: '1,2,3',
              }
            })
              .then(response => {
                this.ac_year_list = response.data.map(
                  el => ({
                    value: el.ac_year_id,
                    ac_status_id: el.ac_status_id,
                    label:
                      el.ac_year +
                      (el.ac_status_id == 1
                        ? ' ( Current ) '
                        : el.ac_status_id == 2
                          ? ' ( History ) '
                          : ' ( Next ) ')
                  })
                )
              })
              .catch(error => {
                this.$toasted.error(error.message)
              })
              .finally(() => {
                this.loading = false
                this.ac_year_list.filter(el => el.ac_status_id == 1).map(el =>
                  this.model.ac_year_id = el.value
                )
              })
          }
        })
    },
    //onChange branch
    onBranchChange() {
      this.model.ac_year_id = null
      this.model.acps_id = null
      this.model.ac_term_id = null
      this.fetching_academic_year = true
      this.getYear({
        filter: {
          ac_status_id: '1,2,3',
          branch_id: this.model.branch_id
        },
        branch_id: [this.model.branch_id]
      })
        .then(response => {
          this.ac_year_list = _.sortBy(response.data, ['ac_status_id']).map(
            el => ({
              value: el.ac_year_id,
              label:
                el.ac_year +
                (el.ac_status_id == 1
                  ? ' ( Current ) '
                  : el.ac_status_id == 2
                    ? ' ( History ) '
                    : ' ( Next ) ')
            })
          )
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching_academic_year = false
        })
    },
    //onMainProgramChange
    async onMainProgramChange(acp_id) {
      this.model.acps_id = null
      await this.getSubProgram({
        filter: {
          acp_id: acp_id
        }
      })
        .then(response => {
          this.sub_programs = response.data.map(el => ({
            value: el.acps_id,
            label: el.acps_name_foreign,
            scoring_cyles: el.scoring_cyles.map(el => el.scoring_cycle_id)
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    //onSubChange
    onSubChange(acps_id) {
      this.model.ac_term_id = null
      this.model.class_id = null
      if (this.model.ac_year_id) {
        this.fetching_academic_term = true
        this.getTerm({
          filter: {
            acps_id: acps_id,
            ac_status_id: '1,2,3',
            ac_year_id: this.model.ac_year_id,
            branch_id: this.model.branch_id
          },
          branch_id: [this.model.branch_id]
        })
          .then(response => {
            this.ac_terms = response.data.map(el => ({
              value: el.ac_term_id,
              term_order: el.term_order,
              label:
                el.term_name +
                (el.ac_status_id == 1
                  ? ' ( Current ) '
                  : el.ac_status_id == 2
                    ? ' ( History ) '
                    : '( Next )')
            }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.fetching_academic_term = false
          })
      }

      this.getScoringCycle({ acps_id: acps_id })
        .then(response => {
          this.scoringCycle = response.data.map(el => ({
            value: el.scoring_cycle_id,
            label: el.scoring_cycle_name
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    //acYearChange
    acYearChange() {
      // this.model.acps_id = null
      this.model.ac_term_id = null
      this.model.class_id = null
      this.model.student_id = undefined
      this.fetching_academic_term = true
      this.getTerm({
        filter: {
          acps_id: this.model.acps_id,
          ac_status_id: '1,2,3',
          ac_year_id: this.model.ac_year_id,
          branch_id: this.model.branch_id
        },
        branch_id: [this.model.branch_id]
      })
        .then(response => {
          this.ac_terms = response.data.map(el => ({
            value: el.ac_term_id,
            term_order: el.term_order,
            label:
              el.term_name +
              (el.ac_status_id == 1
                ? ' ( Current ) '
                : el.ac_status_id == 2
                  ? ' ( History ) '
                  : '( Next )')
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching_academic_term = false
        })
    },
    //acTermChange
    acTermChange(ac_term_id) {
      //For Asean get cycle_value
      if (
        this.model.scoring_cycle_id == 0 ||
        this.model.scoring_cycle_id == 2 ||
        this.model.scoring_cycle_id == 3 ||
        this.model.scoring_cycle_id == 6
      ) {
        this.model.cycle_value = this.ac_terms.find(
          el => el.value == this.model.ac_term_id
        ).term_order
      } else {
        this.model.cycle_value = null
      }
      this.term_order = this.ac_terms.find(
        el => el.value == this.model.ac_term_id
      ).term_order
      this.fetching_class_operation = true
      this.model.class_id = null
      this.getClass({
        filter: {
          ac_term_id: ac_term_id,
          branch_id: this.model.branch_id
        },
        branch_id: [this.model.branch_id]
      })
        .then(response => {
          this.class_options = response.data.map(el => ({
            value: el.class_id,
            label:
              el.class_name +
              ' | ' +
              (el.teacher ? el.teacher.full_name_en + ' | ' : '') +
              el.academic_study_time.study_time,
            grade_id: el.grade_id
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching_class_operation = false
        })
    },
    // scoringCycleChange
    async scoringCycleChange(scoring_cycle_id) {
      await this.getScoringCycleValue({ scoring_cycle_id: scoring_cycle_id })
        .then(response => {
          this.scoringCycleValue = response.data.map(el => ({
            value: el.scoring_cycle_value,
            label: el.scoring_cycle_description,
            scoring_cycle_id: el.scoring_cycle_id
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
      // if (this.model.scoring_cycle_id == 4) {
      //   this.grade = []
      //   this.class_options = []
      //   this.students = []
      //   this.model.ac_term_id = null
      //   this.model.class_id = null
      //   this.model.grade_id = null
      //   this.model.cycle_value = null
      //   this.model.student_id = undefined
      // }
      if (
        this.model.scoring_cycle_id == 0 ||
        this.model.scoring_cycle_id == 2 ||
        this.model.scoring_cycle_id == 3 ||
        this.model.scoring_cycle_id == 6
      ) {
        this.model.cycle_value = this.ac_terms.find(
          el => el.value == this.model.ac_term_id
        ).term_order
      } else {
        this.model.cycle_value = null
      }
    },
    //classChange
    classChange() {
      this.model.student_id = undefined
      this.fetching_student = true
      this.getStudentPofileAllBranch({
        class_id: this.model.class_id   // ← match backend's $request->class_id
      })
        .then(response => {
          this.students = response.data.map(el => ({
            value: el.student_id,
            label: el.full_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching_student = false
        })
      this.getGrades()
    },
    // get grade by class room
    getGrades() {
      this.model.grade_id = this.class_options.find(
        el => el.value == this.model.class_id
      ).grade_id
    },
    onChangeSubmissionDate(dateString) {
      this.model.issue_date = dateString
    },
    preview() {
      this.waiting = true
      this.src = ''
      this.errors = new Errors()
      this.reportCard(this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel() {
      this.exporting = true
      this.errors = new Errors()

      this.$store
        .dispatch('reportAcademic/exportCardExcel', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    }
  },
  watch: {
    'model.branch_id': function (val) {
      if (val) {
        this.onBranchChange()
      }
    }
  }
}
</script>
